import React, { useState, useEffect } from "react";
import { handleGetRequest } from "../../../services/GetTemplate";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { useHistory } from "react-router-dom";
import "../../../components/DataTable.css";
import AddEditModule from "./AddEditModule";

function Module() {
  const [module, setModule] = useState([]);
  const [loading, setloading] = useState([]);
  const [displayModal, setDisplayModal] = useState(false);
  const [setPosition] = useState("center");
  const [editable, setEditable] = useState(false);
  const [moduleRowData, setmoduleRowData] = useState("");
  const [rows, setRows] = useState(20);
  const [first, setFirst] = useState(0);

  const handlePageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
  };

  let history = useHistory();

  const editHandler = (rowData) => {
    setDisplayModal(true);
    setmoduleRowData(rowData);
    setEditable(true);
  };

  const getModule = async () => {
    setloading(true);
    const response = await handleGetRequest("zbizgateway/nonFin/getAllModule");
    setModule(response?.data);
    setloading(false);
  };

  useEffect(() => {
    getModule();
  }, []);

  const actionTemplate = (rowData) => {
    return (
      <div>
        <Button
          tooltip="Edit"
          icon="pi pi-pencil"
          tooltipOptions={{ position: "top" }}
          onClick={() => editHandler(rowData)}
          className="p-button-rounded p-button-secondary p-mr-2"
        />
        <Button
          tooltip="View Details"
          tooltipOptions={{ position: "top" }}
          icon="pi pi-eye"
          onClick={() => history.push(`/getmenu/${rowData?.moduleId}`)}
          className="p-button-rounded p-button-warning p-mr-2"
        />
      </div>
    );
  };

  const dialogFuncMap = {
    displayModal: setDisplayModal,
  };

  const onClick = (name, position) => {
    dialogFuncMap[`${name}`](true);

    if (position) {
      setPosition(position);
    }
  };

  const onHide = (name) => {
    setDisplayModal(false);
  };

  return (
    <div>
      <Dialog
        header={editable ? "Edit Module" : "Add Module"}
        visible={displayModal}
        style={{ width: "50vw" }}
        onHide={() => onHide("displayModal")}
      >
        <AddEditModule
          onHide={onHide}
          editable={editable}
          moduleRowData={moduleRowData}
          getModule={getModule}
        />
      </Dialog>
      <div className="page_header">
        <div
          className="Top__Btn"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div className="d_align">
            <i
              className="pi pi-arrow-circle-left mr-1"
              onClick={() => history.goBack()}
            />
            <h3 className="mod_heading">Module</h3>
          </div>
          <Button
            label="Add New"
            className="Add_New"
            onClick={() => onClick("displayModal", setEditable(false))}
          />
        </div>
      </div>
      <div className="card p-datatable-sm">
        <DataTable
          loading={loading}
          paginator
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
          rows={rows}
          first={first}
          rowsPerPageOptions={[10, 20, 50, 100, 200]}
          onPage={handlePageChange}
          value={module}
          emptyMessage="No data found."
        >
          <Column filter field="moduleName" header="Module Name" />
          <Column filter field="moduleCode" header="Module Code" />
          <Column body={actionTemplate} header="Action" />
        </DataTable>
      </div>
    </div>
  );
}

export default Module;
